import { ComponentStyleConfig } from "@chakra-ui/theme";
// import { mode } from "@chakra-ui/theme-tools";

const Button: ComponentStyleConfig = {
  baseStyle: {
    fontWeight: "medium",
    letterSpacing: "semitight",
  },

  sizes: {
    sm: {
      height: "auto",
      paddingY: "space-8",
      paddingX: "space-16",
      fontSize: "font-13",
      lineHeight: 1,

    },
    md: {
      height: "auto",
      paddingY: { base: "space-14", md: "space-16" },
      paddingX: "space-24",
      fontSize: "font-14",
      lineHeight: 1.1,

    },
    lg: {
      height: "auto",
      paddingY: { base: "space-14", md: "space-16" },
      paddingX: "space-24",
      fontSize: "font-14",
      lineHeight: 1.2,

    },
  },

  variants: {
    primary: {
      lineHeight: 1.2,
      borderRadius: "full",
      bg: "btn-green-bg",
      color: "btn-green-text",

      _hover: {
        background: "btn-green-hover",
      },
    },

    primaryYellow: {
      lineHeight: 1.1,
      borderRadius: "full",
      bg: "btn-yellow-bg",
      color: "btn-yellow-text",

      _hover: {
        background: "btn-yellow-hover",
      },
    },

    signup: {
      lineHeight: 1.2,
      borderRadius: "full",
      bg: "btn-signup-bg",
      color: "btn-signup-text",

      _hover: {
        background: "btn-signup-hover",
      },
    },

    secondary: {
      borderRadius: "full",
      bg: "transparent",
      color: "btn-secondary-text",
      borderColor: "btn-secondary-border",
      borderWidth: "0.97px",
      _hover: {
        background: "btn-secondary-hover",
      },
    },

    // Previously Secondary Button are now namely Tertiary
    tertiary: {
      fontSize: "font-14",
      lineHeight: 1.2,
      borderRadius: "none",
      bg: "transparent",
      color: "btn-green-bg",
      paddingX: 0,
      paddingY: 0,
      borderBottom: "2px solid",
      paddingBottom: "space-6",
      _hover: {
        color: "btn-green-hover",
      },
    },

    yellow: {
      lineHeight: 1.1,
      borderRadius: "full",
      bg: "yellow-0",
      color: "text-primary",

      _hover: {
        background: "btn-yellow-hover",
        color: "text-primary",
      },
    },
    lightYellow: {
      lineHeight: 1.1,
      borderRadius: "full",
      bg: "yellow-3",
      color: "text-primary",

      _hover: {
        background: "yellow-5",
        color: "text-primary",
      },
    },
    lightGrey: {
      lineHeight: 1.1,
      borderRadius: "full",
      bg: "greyLight-4",
      color: "text-primary",

      _hover: {
        background: "yellow-5",
      },
    },

    /**
     * We use `link-standard` for buttons that look like links,
     * because in Contentful we already pass a `link` value
     * which maps to a button that doesn't really look like a link.
     */
    link: {
      lineHeight: "inherit",
      paddingX: 0,
      paddingY: 0,
      color: "grey-1",
      _hover: {
        textDecoration: "none",
      },
    },

    "link-navbar": {
      color: "text-primary",
      fontSize: "font-14",
      lineHeight: "1.5",
      fontWeight: "normal",
      borderRadius: "md",

      _hover: {
        bg: "secondary-stone-50",

      },
    },

    icon: {
      _hover: {
        bg: "greyLight-4",
      },
    },
  },

  defaultProps: {
    variant: "primary",
    size: "md",
  },
};

export default Button;
